module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/MasterCard-1d8ee5a05e0aec977f2406ef6f9dbccd.svg";